import * as React from 'react';
import {Button} from 'semantic-ui-react';
import {setState} from './state';

import {utils} from '../../../lib/utils';

import './index.scss';

function DeleteModal(props: any) {
  const {handleCloseModal, users, destroy} = props;
  const state = setState();

  return (
    <div className="a__users-delete-modal">
      <div className="b__title c__before-title">
        <h1>ユーザーを削除</h1>
      </div>
      <div className="b__messages">
        <p>
          {utils.str.replaceTofu(users.detail.displayName)}
          を削除しますか？
        </p>
      </div>
      <div className="b__actions">
        <Button
          type="button"
          onClick={handleCloseModal}
          disabled={state.loading}
        >
          キャンセル
        </Button>
        <Button
          color="red"
          className="submit"
          onClick={() => {
            destroy(state, props, users.detail);
          }}
          disabled={state.loading}
          loading={state.loading}
        >
          ユーザーを削除する
        </Button>
      </div>
    </div>
  );
}

export default DeleteModal;
